import styled from 'astroturf/react';

export const Avatar = styled.img<{ altLook?: boolean; small?: boolean }>`
  border-radius: 3px;
  height: 60px;
  margin-right: 8px;
  object-fit: cover;
  width: 60px;

  &.small {
    height: 36px;
    width: 36px;
  }

  &.altLook {
    border-radius: 50%;
  }
`;

export const Card = styled.section<{ altLook?: boolean }>`
  border-bottom: 1px solid #ddd;

  &.altLook {
    border-bottom: 0;
  }
`;

export const Header = styled.header<{ altLook?: boolean }>`
  align-items: center;
  background: #f8f8f8;
  border: 1px solid #ddd;
  border-top: 0;
  color: #777;
  display: flex;
  font-size: 11px;
  height: 25px;
  letter-spacing: 0.5px;
  padding-left: 12px;
  text-transform: uppercase;

  &.altLook {
    align-items: flex-end;
    background: transparent;
    border-left: 0;
    border-right: 0;
    font-size: 12px;
    height: 34px;
    justify-content: space-between;
    margin-left: 12px;
    padding-left: 0px;
  }

  @media (max-width: 992px) {
    background: #f3f4fa;
  }
`;

export const Institution = styled.p<{ altLook?: boolean; small?: boolean }>`
  color: #777;
  font-size: 13px;
  margin: 0;

  &.small {
    font-size: 12px;
  }

  &.altLook {
    color: #888;
  }
`;

const Button = styled.button<{ gray?: boolean }>`
  align-items: center;
  background-color: #f0f1f9;
  border: 0;
  color: #0854d3;
  display: flex;
  font-weight: 500;
  height: 36px;
  justify-content: center;
  padding: 0 16px;
  text-align: center;
  white-space: nowrap;

  &.gray {
    background: #f8f8f8;
    color: #777;
  }

  &:not(:last-of-type) {
    margin-right: 12px;
  }
`;

export const RoundButton = styled(Button)`
  border-radius: 18px;
  margin: 8px 0;
`;

export const ViewAll = styled.a<{ altLook?: boolean }>`
  color: #0954d3;
  cursor: pointer;
  display: block;
  font-size: 14px;
  font-weight: 500;
  padding: 8px 12px;

  &.altLook {
    font-size: 12px;
    font-weight: 400;
    text-transform: none;
    padding-bottom: 2px;
  }
`;
